import { Dialog, DialogTitle, Divider } from "@material-ui/core";
import React, { useEffect, useMemo, useRef } from "react";
import FlexRow from "../FlexBox/FlexRow";
import Typography from "../Typography/Typography";
import FlexColumn from "../FlexBox/FlexColumn";
import { XIcon } from "@phosphor-icons/react";
import SButton from "../SButton/SButton";
import useIsMobile from "../../hooks/useIsMobile";
import './SDialog.css'

const SDialog = ({
    open = false,
    onClose,
    hideCloseIcon = false,
    width = '40%',
    title = '',
    description = '',
    descriptionConfig = {
        color: 'var(--grey-400)',
        variant: 'b3M'
    },
    titleConfig = {
        color: 'var(--grey-900)',
        variant: 'h5M'
    },
    primaryButtonConfig = {
        text: '',
        color: 'brand',
        onClick: () => { },
        disabled: false,
        fullWidth: true,
    },
    secondaryButtonConfig = {
        text: '',
        color: 'grey',
        onClick: () => { },
        disabled: false,
        fullWidth: true,
        variant: 'secondary'
    },
    iconButtonConfig = {
        icon: null,
        disabled: false,
        color: 'var(--grey-500)',
        onClick: () => { },
    },
    actionsContainer = {
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        wrap: 'nowrap'
    },
    noteConfig = {
        text: '',
        color: 'var(--error-500)',
        variant: 'b3M',
        align: 'center'
    },
    isFormDialog = false,
    children }) => {

    const isMobile = useIsMobile();

    const onCloseRef = useRef(onClose);
    useEffect(() => {
        onCloseRef.current = onClose;
    }, [onClose]);

    useEffect(() => {
        if (!open || !isMobile || !isFormDialog) return;
        console.log({ title })

        if (window.location.hash !== "#dialog") {
            window.location.hash = "dialog";
        }

        const handleHashChange = () => {
            if (window.location.hash !== "#dialog") {
                onCloseRef.current?.();
            }
        };

        window.addEventListener("hashchange", handleHashChange);

        return () => {
            window.removeEventListener("hashchange", handleHashChange);

            // remove hash when dialog closes normally
            if (window.location.hash === "#dialog") {
                window.history.back();
            }
        };
    }, [open, isMobile, isFormDialog]);

    const isFullScreen = useMemo(() => {
        if (isFormDialog && isMobile) {
            return true;
        }

        return false;
    }, [isFormDialog, isMobile]);

    const hPrimaryClick = () => {
        primaryButtonConfig?.onClick && primaryButtonConfig?.onClick();
    }

    const hSecondaryClick = () => {
        secondaryButtonConfig?.onClick && secondaryButtonConfig?.onClick();
    }

    const hIconButtonClick = () => {
        iconButtonConfig?.onClick && iconButtonConfig?.onClick();
    }

    return (
        <Dialog open={open} fullWidth fullScreen={isFullScreen} PaperProps={{
            style: {
                maxWidth: !isFullScreen ? isMobile ? '97%' : width : 'auto',
                padding: '0',
                display: "flex",
                flexDirection: "column",
                maxHeight: !isFullScreen ? "90vh" : 'auto',
                borderRadius: !isFullScreen ? '1rem' : '0',
            }
        }}>
            <FlexRow flexWrap="nowrap" styles={{ padding: '1rem 2rem' }}>
                <FlexColumn flexWrap="nowrap" gap="0" alignItems="start">
                    <Typography variant={titleConfig?.variant || "h5M"} color={titleConfig?.color || 'var(--grey-900)'}>{title}</Typography>
                    {description && <Typography variant={descriptionConfig?.variant || "b3M"} color={descriptionConfig?.color || 'var(--grey-400)'}>{description}</Typography>}
                </FlexColumn>
                {!hideCloseIcon && (
                    <SButton variant={"tertiary"} color="grey" onClick={() => { onClose && onClose() }}>
                        <XIcon size={20} weight="bold" />
                    </SButton>
                )}
            </FlexRow>
            <Divider />
            <FlexColumn className="SDialog-main" justifyContent="start" alignItems="start" gap="0.4rem" styles={{ overflowY: "auto", padding: `1rem ${isMobile ? '1' : '2'}rem`, height: '100%' }}>
                {children}
            </FlexColumn>
            <Divider />
            {(primaryButtonConfig?.text || secondaryButtonConfig?.text) &&
                <FlexColumn gap='0.2rem' styles={{ padding: (secondaryButtonConfig?.text && primaryButtonConfig?.text) ? `1rem ${isMobile ? '1' : '2'}rem` : `1rem ${isMobile ? '1' : '3'}rem`, paddingTop: noteConfig?.text ? '0.2rem' : '1rem' }}>
                    {noteConfig?.text && <FlexRow justifyContent={noteConfig?.align || "center"}>
                        <Typography variant={noteConfig?.variant || "b3M"} color={noteConfig?.color || "var(--error500)"} >{noteConfig?.text}</Typography>
                    </FlexRow>}
                    <FlexRow flexWrap="nowrap" justifyContent='space-between'>
                        {iconButtonConfig?.icon && <SButton variant={"tertiaryWrap"} style={{ color: iconButtonConfig?.color || 'var(--grey500)' }} onClick={hIconButtonClick}>{iconButtonConfig?.icon}</SButton>}
                        <FlexRow flexWrap={actionsContainer?.wrap || "nowrap"} justifyContent={actionsContainer?.justifyContent || "center"} alignItems={actionsContainer?.alignItems || "center"} width={actionsContainer?.width || '100%'}>
                            {secondaryButtonConfig?.text &&
                                <SButton
                                    variant={secondaryButtonConfig?.variant || "secondary"}
                                    color={secondaryButtonConfig?.color || 'grey'}
                                    size="medium"
                                    onClick={hSecondaryClick}
                                    disabled={!!secondaryButtonConfig?.disabled}
                                    minWidth={true}
                                    fullWidth={secondaryButtonConfig?.fullWidth === false ? false : true}>
                                    {secondaryButtonConfig?.text}
                                </SButton>
                            }
                            {primaryButtonConfig?.text &&
                                <SButton
                                    variant={"primary"}
                                    size="medium"
                                    color={primaryButtonConfig?.color || "brand"}
                                    disabled={!!primaryButtonConfig?.disabled}
                                    onClick={hPrimaryClick}
                                    minWidth={true}
                                    fullWidth={primaryButtonConfig?.fullWidth === false ? false : true}>
                                    {primaryButtonConfig?.text}
                                </SButton>
                            }
                        </FlexRow>
                    </FlexRow>
                </FlexColumn>
            }
        </Dialog>
    )
};

export default SDialog;